// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3jnKU","filesListContainer":"PosDisputesFiles_filesListContainer__NQPx6","filesButton":"PosDisputesFiles_filesButton__2O2pa"};